/**
 * Calculates the percent change between two values, provided as named fields in an object.
 *
 * @param params An object containing the initial and final values.
 * @param params.initialValue The initial value before the change.
 * @param params.finalValue The final value after the change.
 * @returns The percent change from the initial value to the final value. The returned value
 * is positive for a net increase and negative for a net decrease.
 */
export function calculatePercentChange({
    initialValue,
    finalValue,
}: {
    initialValue: number | null;
    finalValue: number | null;
}): number {
    if (initialValue === null || finalValue === null) {
        return 0;
    }

    if (initialValue === 0) {
        return 0;
    }
    const change = finalValue - initialValue;
    const percentChange = change / initialValue;
    return percentChange;
}
